export const AUDITVIEWER_PATH = `audit-viewer`
